import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { META_VIEWPORT_OTHER } from '../../../../resources/config';
import { Store } from '@ngrx/store';
import { RootState } from '../../../../reducers';
import { setCommonIdBrowserTitle } from '../../../../actions/common-id/common-id-core.actions';
import { setTitle } from '../../../../actions/core.actions';
import { getCookie } from 'typescript-cookie';
import { COOKIE_NAME_SSC_ID } from '../../../../resources/common-id-config';

@Component({
  selector: 'app-common-id-tokusyouhou',
  templateUrl: './tokusyouhou.component.html',
  styleUrls: ['./tokusyouhou.component.scss']
})
export class CommonIdTokusyouhouComponent implements OnInit {
  private title = '特定商取引法';

  constructor(private store: Store<RootState>, private meta: Meta) {}

  ngOnInit() {
    this.store.dispatch(setCommonIdBrowserTitle({ subTitle: this.title }));
    setTimeout(() => this.store.dispatch(setTitle({ title: this.title })));
    this.meta.updateTag(META_VIEWPORT_OTHER);

    const sscId = getCookie(COOKIE_NAME_SSC_ID) || '';
    if (sscId) {
      gtag('set', 'user_properties', { ssc_id: sscId });
    }
  }
}
